import React, { Component } from "react";
import PropTypes from "prop-types";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    setActivityIndicator?: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
};

type State = {
    breadcrumbs: IBreadcrumbs[];
};

class Automation extends Component<Props, State> {
    readonly state: State = {
        breadcrumbs: [
            { title: "Dashboard", url: "/dashboard" },
            { title: "Automation", url: "/automation" },
        ],
    };

    render() {
        return (
            <div className="CoopAdvertisement">
                <Breadcrumbs navItems={this.state.breadcrumbs} />

                <div className="row">
                    <OwTitle className={"mt-3 col-12"} title={"automation"} leftIconName={"fad fa-conveyor-belt-alt"} />
                </div>
                <div className={"row"}>
                    <div className={"col-12 "}>Automations and Details Here...</div>
                </div>
            </div>
        );
    }
}

export default Automation;
